import { render, staticRenderFns } from "./eventManagement.vue?vue&type=template&id=ac8777b6&scoped=true"
import script from "./eventManagement.vue?vue&type=script&lang=js"
export * from "./eventManagement.vue?vue&type=script&lang=js"
import style0 from "./eventManagement.vue?vue&type=style&index=0&id=ac8777b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8777b6",
  null
  
)

export default component.exports